const features = [
  {
    icon: 'ri-movie-2-line',
    title: '海量高清资源',
    desc: '收录超过两万部影视作品，涵盖动作、喜剧、悬疑、科幻、爱情等全品类，满足各类影迷的观影需求，每日持续扩充更新。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速流畅播放',
    desc: '采用多CDN智能加速和自适应码率技术，根据你的网络环境自动匹配最佳播放参数，告别卡顿与缓冲，畅享丝滑观影。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端无缝适配',
    desc: '电脑、平板、手机三端完美呈现，无需下载安装任何客户端，打开浏览器即可观看，横竖屏自由切换，随时随地追剧。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '安全绿色观影',
    desc: '平台严格筛选资源来源，无弹窗广告骚扰，无恶意跳转链接，致力于为影迷提供纯净安心的在线观影环境。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            为什么数百万影迷选择被窝网电影
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-7 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}